export const STATES = [
    {
        viewValue: 'Andaman and Nicobar Islands',
        value: 'AN',
    },
    {
        viewValue: 'Andhra Pradesh',
        value: 'AP',
    },
    {
        viewValue: 'Arunachal Pradesh',
        value: 'AR',
    },
    {
        viewValue: 'Assam',
        value: 'AS',
    },
    {
        viewValue: 'Bihar',
        value: 'BR',
    },
    {
        viewValue: 'Chandigarh',
        value: 'CH',
    },
    {
        viewValue: 'Chhattisgarh',
        value: 'CT',
    },
    {
        viewValue: 'Dadra and Nagar Haveli',
        value: 'DN',
    },
    {
        viewValue: 'Daman and Diu',
        value: 'DD',
    },
    {
        viewValue: 'Delhi',
        value: 'DL',
    },
    {
        viewValue: 'Goa',
        value: 'GA',
    },
    {
        viewValue: 'Gujarat',
        value: 'GJ',
    },
    {
        viewValue: 'Haryana',
        value: 'HR',
    },
    {
        viewValue: 'Himachal Pradesh',
        value: 'HP',
    },
    {
        viewValue: 'Jammu and Kashmir',
        value: 'JK',
    },
    {
        viewValue: 'Jharkhand',
        value: 'JH',
    },
    {
        viewValue: 'Karnataka',
        value: 'KA',
    },
    {
        viewValue: 'Kerala',
        value: 'KL',
    },
    {
        viewValue: 'Ladakh',
        value: 'LA',
    },
    {
        viewValue: 'Lakshadweep',
        value: 'LD',
    },
    {
        viewValue: 'Madhya Pradesh',
        value: 'MP',
    },
    {
        viewValue: 'Maharashtra',
        value: 'MH',
    },
    {
        viewValue: 'Manipur',
        value: 'MN',
    },
    {
        viewValue: 'Meghalaya',
        value: 'ML',
    },
    {
        viewValue: 'Mizoram',
        value: 'MZ',
    },
    {
        viewValue: 'Nagaland',
        value: 'NL',
    },
    {
        viewValue: 'Odisha',
        value: 'OR',
    },
    {
        viewValue: 'Puducherry',
        value: 'PY',
    },
    {
        viewValue: 'Punjab',
        value: 'PB',
    },
    {
        viewValue: 'Rajasthan',
        value: 'RJ',
    },
    {
        viewValue: 'Sikkim',
        value: 'SK',
    },
    {
        viewValue: 'Tamil Nadu',
        value: 'TN',
    },
    {
        viewValue: 'Telangana',
        value: 'TG',
    },
    {
        viewValue: 'Tripura',
        value: 'TR',
    },
    {
        viewValue: 'Uttar Pradesh',
        value: 'UP',
    },
    {
        viewValue: 'Uttarakhand',
        value: 'UT',
    },
    {
        viewValue: 'West Bengal',
        value: 'WB',
    },
    {
        viewValue: 'Dubai',
        value: 'DXB',
    },
    {
        viewValue: 'Sharjah',
        value: 'SHJ',
    },
    {
        viewValue: 'Abu Dhabi',
        value: 'AUH',
    },
];
